import React from 'react';
import { connect, ConnectedProps } from 'react-redux'
import { RootState } from '../../store';
import uorsService from '../../services/uors.service';
import ruoliUorService from '../../services/ruoliUor.service';
import userNotificationsService from '../../services/userNotifications.service';
import { myTheme } from '../../assets/styles/my-theme';
import { Selection, Text, CheckboxVisibility, CommandBar, DefaultButton, DetailsList, DetailsListLayoutMode, Dialog, DialogFooter, DialogType, IButtonProps, ICommandBarItemProps, ICommandBarStyles, IDialogContentProps, IPersonaProps, IPersonaStyles, Label, mergeStyleSets, Persona, PersonaSize, PrimaryButton, SelectionMode, Pivot, PivotItem, IPivotStyles, MessageBar, MessageBarType, TooltipHost, IContextualMenuItem, ContextualMenu, ContextualMenuItemType } from '@fluentui/react';
import CustomCommandBarMenuItem from '../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import { IMailboxUor, IUor, IUser, IUserNotifications } from '../../shared/interfaces';
import { Tree, TreeSelectionKeys } from 'primereact/tree';
import { subject, Unsubscribe } from '@casl/ability';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OrganigrammaNodeTemplate from './OrganigrammaNodeTemplate';
import AddEditUor from './AddEditUor';
import AddEditUser from './AddEditUser';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import abilityBuild from '../../shared/CASL/appAbility';
import { checkRoles } from '../../hoc/CheckRoles';
import { MailboxUor_Type, RoleContext } from '../../shared/enums';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import usersService from '../../services/users.service';
import { toastRef } from '../Layout/Layout';
import AddMailbox from './AddMailbox';
import mailboxesUorService from '../../services/mailboxesUor.service';

const queryString = require('query-string');

const { palette } = myTheme;

const classNames = mergeStyleSets({
    overFlowHidden: {
        overflow: 'hidden'
    },
    detailsListRow: {
        '.ms-DetailsRow-check': {
            height: '100%',
            width: 36,
            display: 'flex',
            alignItems: 'center'
        },
        '.ms-DetailsRow-fields .ms-DetailsRow-cell': {
            paddingLeft: 0,

        },
    },
});

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' },
};
const pivotBarStyles: Partial<IPivotStyles> = {

    root: { padding: '0 24px' },
    itemContainer: { overflow: 'hidden', height: '100%' }
};

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    isMobile: state.sessionReducer.isMobile,
})
const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface OrganigrammaProps {

}

type Props = OrganigrammaProps & RouteComponentProps & PropsFromRedux;

export interface OrganigrammaState {
    commandBarItems: ICommandBarItemProps[],
    organigrammaFlatArray: IUor[],
    organigrammaNodes: any[],
    organigrammaExpandedNodes,
    selectedUor?: IUor,
    selectedUorNodeKey?: TreeSelectionKeys,
    selectedPersona?: IUser,
    peopleList: IUser[],
    selectedMailbox?: IMailboxUor,
    mailboxesList: IMailboxUor[],
    isMailIn?: boolean,
    lateralPanelIsOpen: boolean,
    lateralPanelBodyContent: Function,
    lateralPanelSubmitFunction: Function,
    confirmDialogIsOpen: boolean,
    confirmDialogContentProps: IDialogContentProps,
    confirmDialogSubmitFunction: Function,
    newUor?: IUor,
    loadingOrganigramma: boolean,
    loadingUsers: boolean,
    loadingMailboxes: boolean,
    showMessageBar: boolean,
    uorMessageError: string,
    selectedPivot: string
    showContextualMenu: boolean
    contextMenuItems: IContextualMenuItem[] | undefined
    menuPosition: any
    iaAssistantEnabled: boolean
}


class Organigramma extends React.Component<Props, OrganigrammaState> {
    unsubscribeFromAbility: Unsubscribe = () => { };
    private peopleSelection: Selection;
    private mailboxSelection: Selection;
    constructor(props) {
        super(props);

        this.peopleSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.peopleSelection.getSelection()[0] as IUser;
                this.setState({ selectedPersona: selection });
            },
        });

        this.mailboxSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.mailboxSelection.getSelection()[0] as IMailboxUor;
                this.setState({ selectedMailbox: selection });
            },
        });

        this.state = {
            commandBarItems: [],
            organigrammaFlatArray: [],
            organigrammaNodes: [],
            organigrammaExpandedNodes: {},
            peopleList: [],
            mailboxesList: [],
            lateralPanelIsOpen: false,
            lateralPanelBodyContent: () => { },
            lateralPanelSubmitFunction: () => { },
            confirmDialogIsOpen: false,
            confirmDialogContentProps: {},
            confirmDialogSubmitFunction: () => { },
            loadingOrganigramma: false,
            loadingUsers: false,
            loadingMailboxes: false,
            showMessageBar: false,
            uorMessageError: "",
            selectedPivot: "utenti",
            showContextualMenu: false,
            contextMenuItems: [],
            menuPosition: undefined,
            iaAssistantEnabled: false
        }
    }


    componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            this.updateCommandBarItems();
            this.setState({ iaAssistantEnabled: abilityBuild.can('use', subject('IFeature', { key: 'IAAssistant', enabled: true })) });
        });

        if (this.props.currentAoo) {
            this.updateCommandBarItems();
            this.getOrganigramma();
        }
    }

    componentDidUpdate(oldProps: Props, oldState: OrganigrammaState) {
        if (oldProps.currentAoo !== this.props.currentAoo) {
            this.updateCommandBarItems();
            this.getOrganigramma();
        }

        if (oldState.selectedUor !== this.state.selectedUor ||
            oldState.selectedPersona !== this.state.selectedPersona ||
            oldState.selectedMailbox !== this.state.selectedMailbox) {
            this.updateCommandBarItems();
        }

        //if (this.props.isMobile && oldProps.isMobile !== this.props.isMobile)
        //    this.updateDocumentAndDetailsPivotBarItems();

    }

    componentWillUnmount() {
        this.unsubscribeFromAbility();
    }

    getOrganigramma = () => {
        if (this.props.currentAoo) {
            this.setState({ loadingOrganigramma: true });
            uorsService.getOrganigrammaAoo(this.props.currentAoo.id)
                .then(uors => {
                    let expandedNodes = {};
                    let organigrammaFlat = []
                    /// Rimappo le uor nel formato TreeNode di prime react, setto tutti i nodi come aperti 
                    /// e creo l'array organigrammaFlat che utilizzo per facilitare la ricerca di una uor nell'organigramma
                    let organigramma = this.remapOrganigrammaNodes(uors, expandedNodes, organigrammaFlat);

                    //let organigramma = [{
                    //    "key": "0",
                    //    "label": "Organigramma",
                    //    "children": children
                    //}];

                    this.setState(
                        {
                            loadingOrganigramma: false,
                            organigrammaFlatArray: organigrammaFlat,
                            organigrammaNodes: organigramma,
                            organigrammaExpandedNodes: expandedNodes
                        })
                })
                .catch(error => {
                    this.setState({ loadingOrganigramma: false });

                });
        }
    }

    remapOrganigrammaNodes = (uorList, expandedNodes: any, organigrammaFlat: IUor[]) => {
        let uors = uorList.map(uorItem => {
            if (uorItem.children && uorItem.children.length)
                expandedNodes[uorItem.id] = true
            organigrammaFlat.push({
                id: uorItem.id,
                nome: uorItem.nome,
                sigla: uorItem.sigla,
                alias: uorItem.alias,
                parentId: uorItem.parentId,
                attiva: uorItem.attiva,
                iaEnabled: uorItem.iaEnabled, 
                aooId: uorItem.aooId

            });
            let children = this.remapOrganigrammaNodes(uorItem.children, expandedNodes, organigrammaFlat)
            return { ...uorItem, key: uorItem.id, label: uorItem.nome, children: children }

        });
        return uors;
    }

    selectUorHandler = (selectedKey, isFromContextMenu: boolean) => {
        let { selectedUorNodeKey, organigrammaFlatArray } = this.state;
        this.peopleSelection.setAllSelected(false);
        this.mailboxSelection.setAllSelected(false);
        // se cambio uor
        if (selectedKey && selectedUorNodeKey !== selectedKey) {
            let selected = organigrammaFlatArray.find(it => it.id === selectedKey);
            if (this.props.currentAoo && selected) {
                this.setState({
                    loadingUsers: true,
                    loadingMailboxes: true,
                    selectedUor: selected,
                    selectedUorNodeKey: selectedKey,
                });
                // setto lo stato degli utenti
                usersService.getAllUsersInSelectedUor(this.props.currentAoo.id, selected.id!)
                    .then(users => {
                        this.setState({
                            loadingUsers: false,
                            peopleList: users
                        });

                    })
                    .catch(error => {
                        toastRef.current?.show({ severity: 'error', summary: "Attenzione", detail: `Impossibile recuperare gli utenti`, life: 5000 });
                        this.setState({
                            loadingUsers: false,
                            peopleList: []
                        });
                    });

                this.getMailboxesUor(selected.id!);

            }
        }
        // se deseleziono la uor
        else if (!isFromContextMenu) {
            this.setState(
                {
                    selectedUor: undefined,
                    selectedUorNodeKey: undefined,
                })

        }
    }

    updateCommandBarItems = () => {
        let { selectedUor, selectedPersona, selectedMailbox, selectedPivot } = this.state;
        let { currentUser } = this.props;

        let newCommandBarItems: ICommandBarItemProps[] = [];

        if (abilityBuild.can('create', 'IUor'))
            newCommandBarItems.push(
                {
                    key: 'addUor',
                    iconProps: { iconName: 'Add' },
                    text: 'Aggiungi UOR',
                    onClick: this.addUorHandler
                });

        if (abilityBuild.can('update', 'IUor') && selectedUor)
            newCommandBarItems.push(
                {
                    key: 'editUor',
                    iconProps: { iconName: 'Edit' },
                    text: 'Modifica UOR',
                    onClick: this.editUorHandler
                });

        if (abilityBuild.can('delete', 'IUor') && selectedUor)
            newCommandBarItems.push(
                {
                    key: 'deleteUor',
                    iconProps: { iconName: 'Delete' },
                    text: 'Elimina UOR',
                    onClick: this.deleteUorHandler
                });

        // Bisogna aggiungere il check su read fascicolo della uor selezionata
        // però per farlo va rivisto il tutto il sistema CheckRoles
        //let fascicoloCheckRuolo: Partial<IFascicolo> = { uorId: selectedUor!.id };
        //&& abilityBuild.can('read', subject('IFascicolo', fascicoloCheckRuolo))

        const userHasAnyUorContextRoleInSelectedUor = currentUser?.ruoliUorContext.some(el => el.uorId === selectedUor?.id)

        if (abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true })) && selectedUor && userHasAnyUorContextRoleInSelectedUor) {
            newCommandBarItems.push({
                key: 'fascicoli',
                iconProps: { iconName: 'DocumentSet' },
                text: 'Fascicoli',
                onClick: (event) => {
                    const parsedQueryString = queryString.parse(this.props.location.search);
                    parsedQueryString.uorId = selectedUor!.id;
                    const newQueryString = queryString.stringify(parsedQueryString);

                    let newLocation = { pathname: `/${this.props.currentAoo!.id}/fascicoli`, search: newQueryString };
                    this.commandBarNavigateItemHandler(event, newLocation);
                }

            });
        }
        if (abilityBuild.can('create', 'IUser') && selectedUor && selectedPivot === 'utenti')
            newCommandBarItems.push({
                key: 'addUser',
                iconProps: { iconName: 'AddFriend' },
                text: 'Aggiungi utente',
                onClick: this.addUserHandler
            });
        if (abilityBuild.can('update', 'IUser') && selectedUor && selectedPersona && selectedPivot === 'utenti')
            newCommandBarItems.push({
                key: 'editUser',
                iconProps: { iconName: 'EditContact' },
                text: 'Modifica utente',
                onClick: this.editUserHandler
            });
        if (abilityBuild.can('delete', 'IUser') && selectedUor && selectedPersona && selectedPivot === 'utenti')
            newCommandBarItems.push({
                key: 'deleteUser',
                iconProps: { iconName: 'UserRemove' },
                text: 'Rimuovi utente',
                onClick: this.deleteUserHandler
            });

        // pulsante add Mailbox 
        if (abilityBuild.can('update', 'IMailbox') && selectedUor && selectedPivot === 'indirizziPosta') {
            newCommandBarItems.push({
                key: 'mailbox',
                iconProps: { iconName: 'Mail' },
                text: 'Aggiungi indirizzo di posta',
                onClick: this.addMailboxHandler
            });
        }
        // elimina mailbox da uor
        if (abilityBuild.can('delete', 'IMailbox') && selectedUor && selectedMailbox && selectedPivot === 'indirizziPosta')
            newCommandBarItems.push({
                key: 'deleteMailboxFromUor',
                iconProps: { iconName: 'Delete' },
                text: 'Rimuovi indirizzo di posta',
                onClick: this.deleteMailboxHandler
            });


        this.setState({ commandBarItems: newCommandBarItems });

    }

    //handler per renindirizzamento ai fascicoli 
    commandBarNavigateItemHandler = (ev: any, newLocation: any) => {
        ev.preventDefault();
        this.props.history.push(newLocation);
    }

    // Click sul button della commandbar
    addUorHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditUor
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Nuova UOR'
                    loading={false}
                    selectedUor={this.state.selectedUor}
                    onSubmit={this.addUorLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                    panelIsEdit={false}
                    iaAssistantEnabled={abilityBuild.can('use', subject('IFeature', { key: 'IAAssistant', enabled: true }))}
                />

            }
        );
    }

    // Click su salva del panel laterale
    addUorLateralPanelSubmit = (uor: Partial<IUor>) => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi creare una nuova UOR?',
            },
            confirmDialogSubmitFunction: () => { this.addUorConfirmDialogSubmit(uor) }

        })

    }

    // Click su conferma del confirm dialog
    addUorConfirmDialogSubmit = (uor: Partial<IUor>) => {
        if (this.props.currentAoo) {
            uor.aooId = this.props.currentAoo.id;
            this.setState({ loadingOrganigramma: true });

            uorsService.addUor(this.props.currentAoo.id, uor)
                .then(result => {
                    this.getOrganigramma();
                    toastRef.current?.show({ severity: 'info', summary: uor.nome, detail: `Creata correttamente`, life: 5000 });

                })
                .catch(error => {
                    this.setState({ loadingOrganigramma: false });

                });

            this.setState({ confirmDialogIsOpen: false })

        }
    }

    // Click sul button della commandbar
    addUserHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditUser
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Aggiungi utente'
                    loading={false}
                    peopleList={this.state.peopleList}
                    selectedUor={this.state.selectedUor}
                    onSubmit={this.addUserLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                />

            }
        );
    }

    // Click su salva del panel laterale
    addUserLateralPanelSubmit = (user: IUser) => {

        if (this.state.peopleList.findIndex(el => el.userPrincipalName === user.userPrincipalName) < 0) {
            this.setState({
                lateralPanelIsOpen: false,
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: `Vuoi aggiungere l'utente?`,
                },
                confirmDialogSubmitFunction: () => { this.addUserConfirmDialogSubmit(user) }

            });
        }
        else {
            toastRef.current?.show({ severity: 'warn', summary: 'Attenzione', detail: `L'utente ${user?.displayName} è già censito`, life: 5000 });


        }

    }

    // Click su conferma del confirm dialog
    addUserConfirmDialogSubmit = (user: IUser) => {
        if (this.props.currentAoo && this.state.selectedUor) {
            let currentAoo = { ...this.props.currentAoo }
            let { selectedUor } = this.state;



            const newRuoloUor = { ...user.ruoliUorContext![0] };// ruoloUor ha solo un elemento, lo creo in AddEditUser.tsx
            newRuoloUor.utente = { ...user };

            this.setState({ loadingUsers: true });


            ruoliUorService.addRuoloUor(currentAoo.id, newRuoloUor)
                .then((addedRuoloUor) => {
                    toastRef.current?.show({ severity: 'info', summary: user?.displayName, detail: `Aggiunto correttamente`, life: 5000 });

                    let rempUserNotification: IUserNotifications[] = user.userNotification ? user.userNotification!.map(el => { return { ...el, userId: addedRuoloUor.userId } }) : [];
                    userNotificationsService.addUserNotifications(currentAoo.id, selectedUor.id!, addedRuoloUor.userId!, rempUserNotification)
                        .then(() => {
                            toastRef.current?.show({
                                severity: 'info',
                                summary: user?.displayName,
                                detail: `Notifiche configurate correttamente`,
                                life: 5000
                            });
                            usersService.getAllUsersInSelectedUor(currentAoo.id, selectedUor.id!)
                                .then(users => {
                                    this.setState(
                                        {
                                            peopleList: users,
                                            loadingUsers: false
                                        })
                                })
                                .catch(error => {
                                    this.setState({ loadingUsers: false });
                                });


                        })
                        .catch(error => {
                            toastRef.current?.show({
                                severity: 'error',
                                summary: user?.displayName,
                                detail: `Notifiche non configurate`,
                                life: 5000
                            });
                            this.setState({ loadingUsers: false });
                        });

                })
                .catch(error => {
                    //// se l'utente non è censito richiamo addUser passando l'intero oggetto utente
                    //// in questo modo EF crea anche l'utente
                    //if (error.response && error.response.status === 404) {
                    //    const { ruoliAooContext, ruoliUorContext, userNotification, defaultAoo, ...newUser } = user

                    //    let ruoloUorFull = {
                    //        ...newRuoloUor,
                    //        utente: { ...newUser }
                    //    };

                    //    ruoliUorService.addRuoloUor(currentAoo.id, ruoloUorFull)
                    //        .then(() => {
                    //            toastRef.current?.show({ severity: 'info', summary: user?.displayName, detail: `Aggiunto correttamente`, life: 5000 });

                    //            userNotificationsService.addUserNotifications(currentAoo.id, selectedUor.id!, user.userId!, user.userNotification!)
                    //                .then(() => {
                    //                    toastRef.current?.show({
                    //                        severity: 'info',
                    //                        summary: user?.displayName,
                    //                        detail: `Notifiche configurate correttamente`,
                    //                        life: 5000
                    //                    });
                    //                    usersService.getAllUsersInSelectedUor(currentAoo.id, selectedUor.id!)
                    //                        .then(users => {
                    //                            this.setState(
                    //                                {
                    //                                    peopleList: users,
                    //                                    loadingUsers: false
                    //                                })

                    //                        })
                    //                        .catch(error => {
                    //                            this.setState({ loadingUsers: false });

                    //                        });

                    //                })
                    //                .catch(error => {
                    //                    toastRef.current?.show({
                    //                        severity: 'error',
                    //                        summary: user?.displayName,
                    //                        detail: `Notifiche non configurate`,
                    //                        life: 5000
                    //                    });
                    //                    this.setState({ loadingUsers: false });
                    //                });


                    //        })
                    //        .catch(error => {
                    //            this.setState({ loadingUsers: false });
                    //            toastRef.current?.show({ severity: 'error', summary: user?.displayName, detail: `Non aggiunto`, life: 5000 });
                    //        });

                    //}
                    //else {
                    this.setState({ loadingUsers: false });
                    toastRef.current?.show({ severity: 'error', summary: user?.displayName, detail: `Non aggiunto`, life: 5000 });

                    //    }
                })


            this.setState({ confirmDialogIsOpen: false })
            this.peopleSelection.setAllSelected(false);

        }
    }

    // Click sul button della commandbar
    editUserHandler = () => {
        let currentAoo = { ...this.props.currentAoo }
        let { selectedUor } = this.state;
        let { selectedPersona } = this.state;

        if (selectedPersona?.displayName == "Utente non disponibile") {
            toastRef.current?.show({ severity: 'warn', summary: "Attenzione!", detail: `Utente non disponibile`, life: 5000 });
        } else {
            this.setState(
                {
                    lateralPanelIsOpen: true,
                    lateralPanelBodyContent: () => <AddEditUser
                        panelIsOpen={this.state.lateralPanelIsOpen}
                        panelHeaderText='Modifica utente'
                        loading={false}
                        peopleList={this.state.peopleList}
                        selectedUor={this.state.selectedUor}
                        selectedPersona={selectedPersona}
                        onSubmit={this.editUserLateralPanelSubmit}
                        onDismiss={this.dismissLateralPanel}
                    />

                }
            );

        }
    }

    // Click su salva del panel laterale
    editUserLateralPanelSubmit = (user: IUser) => {

        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: `Vuoi modificare l'utente?`,
            },
            confirmDialogSubmitFunction: () => { this.editUserConfirmDialogSubmit(user) }
        })

    }

    // Click su conferma del confirm dialog
    editUserConfirmDialogSubmit = (user: IUser) => {
        if (this.props.currentAoo && this.state.selectedUor) {
            let currentAoo = { ...this.props.currentAoo }
            let { selectedUor } = this.state;

            // ruoloUor ha solo un elemento, lo creo in AddEditUser.tsx
            let newRuoloUor: any = user.ruoliUorContext![0];

            ruoliUorService.updateRuoloUor(currentAoo.id, newRuoloUor)
                .then(result => {
                    this.setState({ loadingUsers: true });

                    toastRef.current?.show({ severity: 'info', summary: user?.displayName, detail: `Aggiornato correttamente`, life: 5000 });

                    userNotificationsService.updateUserNotifications(currentAoo.id, selectedUor.id!, user.id!, user.userNotification!)
                        .then(() => {
                            toastRef.current?.show({
                                severity: 'info',
                                summary: user?.displayName,
                                detail: `Notifiche aggiornate`,
                                life: 5000
                            });
                            usersService.getAllUsersInSelectedUor(currentAoo.id, selectedUor.id!)
                                .then(users => {
                                    this.setState(
                                        {
                                            peopleList: users,
                                            loadingUsers: false
                                        })
                                })
                                .catch(error => {
                                    this.setState({ loadingUsers: false });

                                });

                        })
                        .catch(error => {
                            toastRef.current?.show({
                                severity: 'error',
                                summary: user?.displayName,
                                detail: `Notifiche non aggiornate`,
                                life: 5000
                            });
                            this.setState({ loadingUsers: false });
                        });

                })
                .catch(error => {
                    toastRef.current?.show({ severity: 'error', summary: user?.displayName, detail: `Non aggiornato`, life: 5000 });

                });

            this.setState({ confirmDialogIsOpen: false })
            this.peopleSelection.setAllSelected(false);

        }
    }

    // Click sul button della commandbar
    deleteUserHandler = () => {
        let { selectedPersona, selectedUor } = this.state;

        if (selectedPersona) {
            this.setState(
                {
                    confirmDialogContentProps: {
                        type: DialogType.normal,
                        title: 'Conferma',
                        closeButtonAriaLabel: 'Close',
                        subText: `Vuoi rimuovere l'utente "${selectedPersona.displayName}" dalla UOR${selectedUor ? ' "' + selectedUor.nome + '"' : ''}?`,
                    },
                    confirmDialogIsOpen: true,
                    confirmDialogSubmitFunction: () => { this.deleteUserConfirmDialogSubmit() }
                }
            );
        }
    }

    // Click su conferma del confirm dialog
    deleteUserConfirmDialogSubmit = () => {
        if (this.props.currentAoo && this.state.selectedUor && this.state.selectedPersona) {

            let person: IUser = { ...this.state.selectedPersona };
            let ruoloUor = person.ruoliUorContext.find(el => el.uorId === this.state.selectedUor?.id);

            if (ruoloUor) {
                ruoliUorService.deleteRuoloUor(this.props.currentAoo.id, ruoloUor)
                    .then(result => {

                        let { peopleList } = this.state;
                        let newPeopleList = peopleList.filter(el => el.id !== ruoloUor?.userId);
                        this.setState({ peopleList: newPeopleList })
                        toastRef.current?.show({ severity: 'info', summary: person?.displayName, detail: `Rimosso`, life: 5000 });

                        userNotificationsService.deleteAllUserNotificationsInUorForSelectedUser(this.props.currentAoo!.id, this.state.selectedUor?.id!, person.id)
                            .then(() => {
                                toastRef.current?.show({
                                    severity: 'info',
                                    summary: person?.displayName,
                                    detail: `Eliminata la configurazione delle notifiche`,
                                    life: 5000
                                });
                            })
                            .catch(error => {
                                toastRef.current?.show({
                                    severity: 'error',
                                    summary: person?.displayName,
                                    detail: `Configurazione delle notifiche non eliminata correttamente`,
                                    life: 5000
                                });
                            });

                    })
                    .catch(error => {
                        toastRef.current?.show({ severity: 'error', summary: person?.displayName, detail: `Non rimosso`, life: 5000 });

                    });
            }
            this.setState({ confirmDialogIsOpen: false })
            this.peopleSelection.setAllSelected(false);
        }
    }

    // Click sul button della commandbar - 'Modifica UOR'
    editUorHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditUor
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Modifica UOR'
                    loading={false}
                    selectedUor={this.state.selectedUor}
                    onSubmit={this.editUorLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                    panelIsEdit={true}
                    iaAssistantEnabled={this.state.iaAssistantEnabled}

                />

            }
        );
    }

    // Click su salva del panel laterale - 'Modifica UOR'
    editUorLateralPanelSubmit = (uor: Partial<IUor>) => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: `Vuoi modificare la UOR?`,

            },
            confirmDialogSubmitFunction: () => { this.editUorConfirmDialogSubmit(uor) }
        })
    }

    // Click su conferma del confirm dialog - 'Modifica UOR'
    editUorConfirmDialogSubmit = (uor: Partial<IUor>) => {
        if (this.props.currentAoo && this.state.selectedUor) {
            let selectedUor: IUor = { ...this.state.selectedUor };
            let currentAoo = { ...this.props.currentAoo };
            this.setState({ loadingOrganigramma: true });

            let newUor = { ...selectedUor, nome: uor.nome, alias: uor.alias, sigla: uor.sigla, aooId: currentAoo.id, iaEnabled: uor.iaEnabled };

            if (newUor.id) {
                uorsService.updateUor(currentAoo.id, newUor.id, newUor)
                    .then(result => {
                        this.getOrganigramma();
                        toastRef.current?.show({
                            severity: 'info',
                            summary: newUor.nome,
                            detail: `Aggiornato correttamente`,
                            life: 5000
                        })
                    })
                    .catch(error => {
                        this.setState({ loadingOrganigramma: false });
                        toastRef.current?.show({
                            severity: 'error',
                            summary: newUor.nome,
                            detail: 'Non aggiornato correttamente',
                            life: 5000
                        });
                    });
            }
            this.setState({ confirmDialogIsOpen: false, selectedUor: newUor })
        }
    }

    deleteUorHandler = () => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: `Vuoi rimuovere la UOR? ATTENZIONE: è un'azione irreversibile`,
            },
            confirmDialogSubmitFunction: () => { this.deleteUorConfirmDialogSubmit() }
        });
    }

    deleteUorConfirmDialogSubmit = () => {
        if (this.props.currentAoo && this.state.selectedUor) {
            let selectedUor: IUor = { ...this.state.selectedUor };
            let currentAoo = { ...this.props.currentAoo };
            this.setState({ loadingOrganigramma: true });

            if (selectedUor.id) {
                uorsService.deleteUor(currentAoo.id, selectedUor.id)
                    .then(result => {
                        this.getOrganigramma();
                        toastRef.current?.show({
                            severity: 'info',
                            summary: selectedUor.nome,
                            detail: `Rimossa`,
                            life: 5000
                        })
                    })
                    .catch(error => {
                        this.setState({ loadingOrganigramma: false });
                        let errorStatusCode = error.response.status;

                        if (errorStatusCode === 400) {
                            this.setState({ showMessageBar: true, uorMessageError: error.response.data })
                        }

                        else {
                            toastRef.current?.show({
                                severity: 'error',
                                summary: selectedUor.nome,
                                detail: 'Non rimossa',
                                life: 5000
                            });
                        }
                    })
            }
            this.setState({ confirmDialogIsOpen: false, selectedUor: undefined, selectedUorNodeKey: undefined });
        }
    }

    // click sulk button della commandbar - "aggiungi mailbox"
    addMailboxHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddMailbox
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Aggiungi indirizzo di posta'
                    loading={false}
                    mailboxesList={this.state.mailboxesList}
                    selectedUor={this.state.selectedUor}
                    onSubmit={this.addMailboxLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}

                />

            }
        );
    }

    // click sul salva del panel laterale - "aggiungi mailbox"
    addMailboxLateralPanelSubmit = (mailbox: IMailboxUor) => {

        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: `Vuoi aggiungere l'indirizzo di posta alla UOR ${this.state.selectedUor ? ' "' + this.state.selectedUor.nome + '"' : ''}'?`,
            },
            confirmDialogSubmitFunction: () => { this.addMailboxConfirmDialogSubmit(mailbox) }
        });
    }


    // Click su conferma del confirm dialog - "Aggiungi mailbox"
    addMailboxConfirmDialogSubmit = (mailboxUor: IMailboxUor) => {
        if (this.props.currentAoo && this.state.selectedUor) {
            let uorId = this.state.selectedUor.id!;
            this.setState({ loadingMailboxes: true, confirmDialogIsOpen: false });

            mailboxesUorService.addMailboxUor(this.props.currentAoo.id, uorId, mailboxUor)
                .then(result => {

                    this.getMailboxesUor(uorId);

                    toastRef.current?.show({
                        severity: 'info',
                        summary: 'Operazione completata',
                        detail: `${mailboxUor.mailbox?.address} aggiunto alla UOR ${this.state.selectedUor?.nome}`,
                        life: 5000
                    });
                })
                .catch(error => {
                    this.setState({ loadingMailboxes: false });

                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: 'Attenzione',
                            detail: `Non è stato possibile aggiungere ${mailboxUor.mailbox?.address} alla UOR ${this.state.selectedUor?.nome}`,
                            life: 5000
                        });
                    }
                })

            this.mailboxSelection.setAllSelected(false);

        }
    }

    // Click sul button della commandbar - "rimuovi mailbox"
    deleteMailboxHandler = () => {
        let { selectedMailbox, selectedUor } = this.state;

        if (selectedMailbox) {
            this.setState(
                {
                    confirmDialogContentProps: {
                        type: DialogType.normal,
                        title: 'Conferma',
                        closeButtonAriaLabel: 'Close',
                        subText: `Vuoi rimuovere la cassetta con indirizzo "${selectedMailbox.mailbox?.address}" dalla UOR${selectedUor ? ' "' + selectedUor.nome + '"' : ''}?`,
                    },
                    confirmDialogIsOpen: true,
                    confirmDialogSubmitFunction: () => { this.deleteMailboxConfirmDialogSubmit() }
                }
            );
        }
    }

    // Click su conferma del confirm dialog
    deleteMailboxConfirmDialogSubmit = () => {
        if (this.props.currentAoo && this.state.selectedUor && this.state.selectedMailbox) {
            let uorId = this.state.selectedUor.id!;
            this.setState({ loadingMailboxes: true, confirmDialogIsOpen: false });

            let mailboxUor: IMailboxUor = { ...this.state.selectedMailbox };

            mailboxesUorService.removeMailboxFromUor(this.props.currentAoo!.id, uorId, mailboxUor.mailbox.id, mailboxUor.type)
                .then(result => {

                    this.getMailboxesUor(uorId);

                    toastRef.current?.show({
                        severity: 'info',
                        summary: 'Operazione completata',
                        detail: `${mailboxUor.mailbox?.address} rimosso alla UOR ${this.state.selectedUor?.nome}`,
                        life: 5000
                    });
                })
                .catch(error => {
                    this.setState({ loadingMailboxes: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: 'Attenzione',
                            detail: `Non è stato possibile rimuovere ${mailboxUor.mailbox?.address} dalla UOR ${this.state.selectedUor?.nome}`,
                            life: 5000
                        });
                    }
                })
            this.mailboxSelection.setAllSelected(false);
        }
    }

    dismissLateralPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ lateralPanelIsOpen: false })
        this.peopleSelection.setAllSelected(false);
        this.mailboxSelection.setAllSelected(false);
    }

    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }

    organigrammaNodeTemplate = (uorNode) => {
        return (
            <OrganigrammaNodeTemplate
                uorNode={uorNode}
            />
        );
    };

    private getMailboxesUor(uorId: number) {
        this.setState({ loadingMailboxes: true })

        return mailboxesUorService.getMailboxesUor(this.props.currentAoo!.id, uorId)
            .then(mailboxes => {
                this.setState(
                    {
                        loadingMailboxes: false,
                        mailboxesList: mailboxes
                    })
            })
            .catch(error => {
                if (!error.isErrorShown) {
                    toastRef.current?.show({
                        severity: 'error',
                        summary: 'Attenzione',
                        detail: `Non è stato possibile recuperare le cassette`,
                        life: 5000
                    });
                }
                this.setState(
                    {
                        loadingMailboxes: false,
                        mailboxesList: []
                    }
                );
            });


    }

    private onRenderDetailsListRowForUsers(rowProps, defaultRender) {

        rowProps.className = classNames.detailsListRow
        rowProps.onRenderDetailsCheckbox = (props, defaultRender) => {

            return defaultRender({ ...props });
        };
        rowProps.onRenderItemColumn = (person) => {
            return <Persona
                {...person}
                imageUrl={person.imageUrl}
                imageInitials={person.initials}
                text={person.displayName}
                secondaryText={person.userPrincipalName}
                showSecondaryText={true}
                hidePersonaDetails={false}
                size={PersonaSize.size32}
            />
        };
        return <div>{defaultRender({ ...rowProps })}</div>;
    }

    onPivotItemClick = (item, ev) => {
        this.peopleSelection.setAllSelected(false);
        this.mailboxSelection.setAllSelected(false);

        this.setState(
            { selectedPivot: item.props.id! },
            () => this.updateCommandBarItems()
        );
    }

    // metodi per context menu
    onShowContextualMenuOrgranigramma = (ev) => {
        ev.originalEvent.preventDefault();

        this.updateContextMenuOrganigramma();
        this.setState({ showContextualMenu: true, menuPosition: ev.originalEvent });

    };

    onShowContextualMenuUsersList = (item, index, ev) => {
        ev.preventDefault();

        this.updateContextMenuUsersList();
        this.setState({ showContextualMenu: true, menuPosition: ev });
    };

    onShowContextualMenuMailboxesList = (item, index, ev) => {
        ev.preventDefault();

        this.updateContextMenuMailboxesList();
        this.setState({ showContextualMenu: true, menuPosition: ev });
    };

    // update array dei 3 menu 
    updateContextMenuOrganigramma = () => {
        let { selectedPivot } = this.state;
        const menuItems: IContextualMenuItem[] = [];

        if (abilityBuild.can('update', 'IUor')) {
            menuItems.push(
                {
                    key: 'modfica',
                    text: 'Modifica UOR',
                    iconProps: { iconName: 'Edit' },
                    onClick: () => {
                        this.editUorHandler();
                        this.onHideContextualMenu();
                    }
                }
            )
        }
        if (abilityBuild.can('delete', 'IUor')) {
            menuItems.push(
                {
                    key: 'elimina',
                    text: 'Elimina UOR',
                    iconProps: { iconName: 'Delete' },
                    onClick: () => {
                        this.deleteUorHandler();
                        this.onHideContextualMenu();
                    }
                }
            )
        }
        if (abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))) {
            menuItems.push(

                {
                    key: 'fascicoli',
                    text: 'Fascicoli',
                    iconProps: { iconName: 'DocumentSet' },
                    onClick: (event) => {
                        this.showFascicoliAfterContextMenuSelection(event);
                        this.onHideContextualMenu();
                    }
                }
            )
        }
        if (abilityBuild.can('create', 'IUser') && selectedPivot === 'utenti') {
            menuItems.push(
                {
                    key: 'addUser',
                    text: 'Aggiungi utente',
                    iconProps: { iconName: 'AddFriend' },
                    onClick: () => {
                        this.addUserHandler();
                        this.onHideContextualMenu();
                    }
                }
            );
        }
        if (abilityBuild.can('update', 'IMailbox') && selectedPivot === 'indirizziPosta') {
            menuItems.push(
                {
                    key: 'addMailbox',
                    text: 'Aggiungi indirizzo di posta',
                    iconProps: { iconName: 'Mail' },
                    onClick: () => {
                        this.addMailboxHandler();
                        this.onHideContextualMenu();
                    }
                }
            );
        }
        this.setState({ contextMenuItems: menuItems });
    }

    showFascicoliAfterContextMenuSelection = (event) => {

        let { selectedUor } = this.state;
        if (selectedUor) {
            const parsedQueryString = queryString.parse(this.props.location.search);
            parsedQueryString.uorId = selectedUor!.id;
            const newQueryString = queryString.stringify(parsedQueryString);
            let newLocation = { pathname: `/${this.props.currentAoo!.id}/fascicoli`, search: newQueryString };
            this.commandBarNavigateItemHandler(event, newLocation);
        }
    }

    updateContextMenuUsersList = () => {
        const menuItems: IContextualMenuItem[] = [];

        if (abilityBuild.can('update', 'IUser')) {
            menuItems.push(
                {
                    key: 'modfica',
                    text: 'Modifica utente',
                    iconProps: { iconName: 'EditContact' },
                    onClick: () => {
                        this.editUserHandler();
                        this.onHideContextualMenu();
                    }
                }
            )
        }
        if (abilityBuild.can('delete', 'IUser')) {
            menuItems.push(
                {
                    key: 'elimina',
                    text: 'Rimuovi utente',
                    iconProps: { iconName: 'UserRemove' },
                    onClick: () => {
                        this.deleteUserHandler();
                        this.onHideContextualMenu();
                    }
                }
            )
        }
        this.setState({ contextMenuItems: menuItems });
    }

    updateContextMenuMailboxesList = () => {
        const menuItems: IContextualMenuItem[] = [];

        if (abilityBuild.can('delete', 'IMailbox')) {
            menuItems.push(
                {
                    key: 'elimina',
                    text: 'Rimuovi indirizzo di posta',
                    iconProps: { iconName: 'Delete' },
                    onClick: () => {
                        this.deleteMailboxHandler();
                        this.onHideContextualMenu();
                    }
                }
            )
        }
        this.setState({ contextMenuItems: menuItems });
    }

    onHideContextualMenu = () => {
        this.setState({ contextMenuItems: undefined, showContextualMenu: false });
    };

    renderOrganigrammaBox() {
        return (
            <div className={`position-relative my-scroll-div`}>

                {this.state.organigrammaNodes.length > 0 ? // se organigramma ha nodi

                    <div className={`my-component-content`}>
                        <Tree
                            nodeTemplate={this.organigrammaNodeTemplate}
                            filter filterMode="strict"
                            filterPlaceholder="Inserire il nome della UOR"
                            value={this.state.organigrammaNodes}
                            expandedKeys={this.state.organigrammaExpandedNodes}
                            selectionMode="single" selectionKeys={this.state.selectedUorNodeKey} onSelectionChange={e => this.selectUorHandler(e.value, false)}
                            onToggle={e => this.setState({ organigrammaExpandedNodes: e.value })}
                            onContextMenuSelectionChange={e => this.selectUorHandler(e.value, true)}
                            onContextMenu={this.onShowContextualMenuOrgranigramma}
                        />

                    </div>
                    // se organigramma non ha nodi, non viene mostrata la searchbar
                    :

                    <div style={{ marginTop: '10px' }}>
                        <Text>Nessuna UOR disponibile</Text>
                    </div>

                }

            </div>
        );
    }
    renderUsersListBox() {
        return (
            <div className={`position-relative my-scroll-div`}>
                <div style={{ position: 'relative', height: '100%' }} >
                    {
                        this.state.peopleList && this.state.peopleList.length > 0
                            ? <DetailsList
                                items={this.state.peopleList}
                                columns={[{
                                    key: 'persona',
                                    fieldName: '',
                                    name: '',
                                    minWidth: 100,
                                }]}
                                isHeaderVisible={false}
                                onRenderRow={this.onRenderDetailsListRowForUsers}
                                layoutMode={DetailsListLayoutMode.justified}
                                selection={this.peopleSelection}
                                selectionPreservedOnEmptyClick={true}
                                selectionMode={SelectionMode.single}
                                checkboxVisibility={CheckboxVisibility.onHover}
                                onItemContextMenu={this.onShowContextualMenuUsersList}
                                onShouldVirtualize={() => false}
                            />
                            : <Text nowrap block>Nessun utente inserito</Text>
                    }
                </div>
            </div>


        );
    }

    renderMailboxesListBox() {
        return (
            <div className={`position-relative my-scroll-div`}>
                <div style={{ position: 'relative', height: '100%' }} className={classNames.detailsListRow} >
                    {
                        this.state.mailboxesList && this.state.mailboxesList.length > 0
                            ? <DetailsList
                                items={this.state.mailboxesList}
                                columns={[{
                                    key: 'mailbox',
                                    fieldName: 'address',
                                    name: '',
                                    minWidth: 100,
                                    onRender: (item: IMailboxUor) => {
                                        return <>
                                            {item.type === MailboxUor_Type.In &&
                                                <span>
                                                    <TooltipHost content="In Entrata" >
                                                        <FontAwesomeIcon icon={{ prefix: 'fas', iconName: 'right-to-line' }} style={{ paddingRight: '20px', color: palette.themePrimary, fontSize: 'medium' }}></FontAwesomeIcon>
                                                    </TooltipHost>
                                                </span>
                                            }
                                            {item.type === MailboxUor_Type.Out &&
                                                <span>
                                                    <TooltipHost content="In Uscita" >
                                                        <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'left-from-line' }} style={{ paddingRight: '20px', color: palette.themePrimary, fontSize: 'medium' }}></FontAwesomeIcon>
                                                    </TooltipHost>
                                                </span>
                                            }
                                            <span style={{ fontSize: 'small' }}>{item.mailbox?.address}</span>
                                        </>
                                    }
                                }]}
                                isHeaderVisible={false}
                                layoutMode={DetailsListLayoutMode.justified}
                                selection={this.mailboxSelection}
                                selectionPreservedOnEmptyClick={true}
                                selectionMode={SelectionMode.single}
                                checkboxVisibility={CheckboxVisibility.onHover}
                                onItemContextMenu={this.onShowContextualMenuMailboxesList}
                                onShouldVirtualize={() => false}
                            />
                            : <Text nowrap block>Nessuna cassetta inserita</Text>
                    }
                </div>
            </div>


        );
    }

    render() {

        return (
            <React.Fragment>

                {this.state.lateralPanelBodyContent()}

                <Dialog
                    hidden={!this.state.confirmDialogIsOpen}
                    onDismiss={this.dismissConfirmDialog}
                    dialogContentProps={this.state.confirmDialogContentProps}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                        <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                    </DialogFooter>

                </Dialog>

                <div className="organigramma-component flex flex-column p-nogutter" >

                    {this.state.commandBarItems.length > 0 &&
                        <CommandBar
                            overflowButtonProps={overflowProps}
                            items={this.state.commandBarItems}
                            styles={commandBarStyles}

                        />

                    }
                    {this.state.showMessageBar &&
                        <MessageBar
                            messageBarType={MessageBarType.blocked}
                            isMultiline={true}
                            onDismiss={() => this.setState({ showMessageBar: false })}
                            dismissButtonAriaLabel="Close">
                            {this.state.uorMessageError}
                        </MessageBar>
                    }

                    <ContextualMenu
                        items={this.state.contextMenuItems!}
                        hidden={!this.state.showContextualMenu}
                        target={this.state.menuPosition}
                        onItemClick={this.onHideContextualMenu}
                        onDismiss={this.onHideContextualMenu}
                    />

                    {
                        this.props.isMobile
                            // if true
                            ? <div className="organigramma-content flex flex-column">
                                <Pivot aria-label="Gestione organigramma" styles={pivotBarStyles} className="flex flex-column organigramma-pivot-component" onLinkClick={this.onPivotItemClick}>
                                    <PivotItem headerText="Organigramma" className="organigramma-pivot-item flex flex-column" >
                                        <div className={"organigramma-tree col-12 lg:col-7 flex flex-column position-relative " + classNames.overFlowHidden}>
                                            <CircleLoader loaderClass='loader-large' loading={this.state.loadingOrganigramma} />

                                            {this.renderOrganigrammaBox()}
                                        </div>
                                    </PivotItem>
                                    {
                                        this.state.selectedUor &&
                                        <>
                                            <Label >{this.state.selectedUor?.nome}:</Label>
                                            <PivotItem id="utenti" headerText="Utenti" className="flex flex-column" >
                                                <div className={"users-list col-12 lg:col-3 flex flex-column position-relative " + classNames.overFlowHidden}>
                                                    <CircleLoader loaderClass='loader-large' loading={this.state.loadingUsers} />
                                                    {this.renderUsersListBox()}
                                                </div>
                                            </PivotItem>
                                            <PivotItem id="indirizziPosta" headerText="E-mail" className="flex flex-column" >
                                                <div className={"users-list col-12 lg:col-3 flex flex-column position-relative " + classNames.overFlowHidden}>
                                                    <CircleLoader loaderClass='loader-large' loading={this.state.loadingMailboxes} />
                                                    {this.renderMailboxesListBox()}
                                                </div>
                                            </PivotItem>

                                        </>
                                    }
                                </Pivot>
                            </div>

                            //else
                            : <div className="organigramma-content flex flex-row p-nogutter">
                                <div className={"organigramma-tree col-12 lg:col-7 flex flex-column position-relative " + classNames.overFlowHidden}>
                                    <CircleLoader loaderClass='loader-large' loading={this.state.loadingOrganigramma} />

                                    {this.renderOrganigrammaBox()}
                                </div>
                                {this.state.selectedUor &&
                                    <>
                                        <div className={"col-12 lg:col-5 flex flex-column position-relative" + classNames.overFlowHidden}>
                                            <Label >{this.state.selectedUor?.nome}:</Label>
                                            <Pivot aria-label="Gestione uor selezionata" styles={pivotBarStyles} className="flex flex-column organigramma-pivot-component" onLinkClick={this.onPivotItemClick}>

                                                <PivotItem id="utenti" headerText="Utenti" className="organigramma-pivot-item flex flex-column">
                                                    <div className="users-section flex flex-column position-relative my-scroll-div">
                                                        <CircleLoader loaderClass='loader-large' loading={this.state.loadingUsers} />
                                                        {this.renderUsersListBox()}
                                                    </div>
                                                </PivotItem>

                                                <PivotItem id="indirizziPosta" headerText="Indirizzi di posta" className="organigramma-pivot-item flex flex-column">
                                                    <div className="mailboxes-section flex flex-column position-relative my-scroll-div">
                                                        <CircleLoader loaderClass='loader-large' loading={this.state.loadingMailboxes} />
                                                        {this.renderMailboxesListBox()}
                                                    </div>
                                                </PivotItem>

                                            </Pivot>


                                        </div>
                                    </>
                                }
                            </div>


                    }
                </div>
            </React.Fragment >

        )
    }
}
export default connector(withRouter(checkRoles(Organigramma, RoleContext.Aoo)));



